import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { CircularAvatar } from "../commons";
import { UserProfileType } from "../../redux/auth/authTypes";
import { Button } from "reactstrap";


type AppProps = {
  data: UserProfileType[] | [];
  tableHeader: TableHeadersType[];
  token: string | null;
  history:any;
  handleShowUserDetails: (data: any) => void;
};
const GovermentDirectoryTableData = ({
  data,
  tableHeader,
  token,
  history,
  handleShowUserDetails,
}: AppProps) => {

  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?.user_id}>
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value === "name") {
                    return (
                      <td style={{ whiteSpace: "nowrap", width: "240px" }}>
                        <div
                          className="ml-2"
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "7px",
                          }}
                          onClick={() => handleShowUserDetails(itemData)}
                        >
                          <CircularAvatar
                            name={`${itemData?.first_name} ${itemData?.last_name} `}
                            image={
                              itemData?.profile_pic &&
                              itemData?.profile_pic?.file_url
                            }
                          />
                          <div
                            style={{
                              textDecoration: "underline",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            {`${itemData?.first_name} ${itemData?.last_name} `}
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "email") {
                    return (
                      <td style={{ whiteSpace: "nowrap" }}>
                        {itemData?.email?.length > 25 ? (
                          <>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view-filter-invoice">
                                  {itemData?.email}
                                </Tooltip>
                              }
                            >
                              <span>
                                {itemData?.email.toLowerCase()?.substr(0, 20) +
                                  (itemData?.email &&
                                  itemData?.email?.length > 20
                                    ? "..."
                                    : "")}
                              </span>
                            </OverlayTrigger>
                            <br></br>
                            <span
                              style={{ color: "#6e7491", fontSize: "12px" }}
                            >
                              {itemData?.mobile_number &&
                                itemData?.mobile_number}
                            </span>
                          </>
                        ) : (
                          <>
                            {itemData?.email}
                            <br></br>
                            <span
                              style={{ color: "#6e7491", fontSize: "12px" }}
                            >
                              {itemData?.mobile_number &&
                                itemData?.mobile_number}
                            </span>
                          </>
                        )}
                      </td>
                    );
                  } else if (header?.value === "job_title") {
                    return (
                      <>
                        <td style={{ fontSize: "14px", minWidth: "300px" }}>
                          {itemData?.job_title}
                          {!itemData?.job_title &&
                            !itemData?.department &&
                            "NA"}
                          <br></br>
                          <span style={{ color: "#6e7491", fontSize: "12px" }}>
                            {itemData?.department}
                          </span>
                        </td>
                      </>
                    );
                  } else if (header?.value === "branch_name") {
                    return (
                      <td style={{ minWidth: "130px" }}>
                        <div>{itemData?.branch_name ? itemData?.branch_name : "NA"}</div>
                      </td>
                    );
                  } else if (header?.value === "mapped_jobs") {
                    return (
                      <td style={{ minWidth: "150px" }}>
                        <div>
                          {
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                              className=" pointer"
                             
                              onClick={() => history.push({
                                  pathname: `/officer-directory/view-all-mapped-jobs/${itemData?.user_id}`,
                                  state: {id:itemData?.user_id}
                                })
                               }
                            >
                              <div>
                                <Button
                                  outline
                                  color="danger"
                                  className="ouline-button-hover"
                                >
                                  View Jobs
                                </Button>
                              </div>
                            </span>                            
                          }
                        </div>
                      </td>
                    );
                  } else {
                    return <td> NA </td>;
                  }
                })}
            </tr>
          );
        })}

    </>
  );
};

export default GovermentDirectoryTableData;


